"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.regionAPIs = void 0;
exports.regionAPIs = new Map([["us", "https://api-iam.intercom.io"], ["eu", "https://api-iam.eu.intercom.io"], ["ap", "https://api-iam.au.intercom.io"]]);